import {
  GENDER_OPTIONS,
  validateInternationalId,
  VALIDATION_KEYS,
} from "@fysaro/shared";
import { z } from "zod";

export const baseSProfessionalSchema = z
  .object({
    // Datos del perfil (UserProfile)
    name: z.string().min(2, VALIDATION_KEYS.PROFESSIONAL.NAME_REQUIRED),
    email: z.string().email(VALIDATION_KEYS.GENERIC.INVALID_EMAIL),
    phone: z.string().optional().nullable(),

    identificationNumber: z
      .string()
      .trim()
      .toUpperCase()
      .or(z.literal(""))
      .transform((val) => (val === "" ? null : val))
      .optional()
      .nullable(),

    // Datos especí­ficos del profesional (Professional)
    specialtyId: z
      .union([
        z.string().uuid(VALIDATION_KEYS.PROFESSIONAL.INVALID_SPECIALTY),
        z.literal(""),
        z.null(),
      ])
      .transform((val) => (val === "" ? null : val))
      .optional(),
    title: z
      .string()
      .max(100, VALIDATION_KEYS.PROFESSIONAL.DEGREE_MAX_LENGTH)
      .optional()
      .nullable(),
    bio: z
      .string()
      .max(1000, VALIDATION_KEYS.PROFESSIONAL.BIO_MAX_LENGTH)
      .optional()
      .nullable(),
    imageUrl: z
      .string()
      .url(VALIDATION_KEYS.GENERIC.INVALID_URL)
      .optional()
      .nullable()
      .default(null),
    licenseNumber: z.string().optional().nullable(),
    color: z
      .string()
      .regex(
        /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
        VALIDATION_KEYS.GENERIC.INVALID_COLOR,
      )
      .default("#3b82f6"),
    gender: z.enum(GENDER_OPTIONS).optional().nullable(),
    birthDate: z.coerce
      .date()
      .max(new Date(), VALIDATION_KEYS.PATIENT.INVALID_AGE)
      .optional()
      .nullable(),

    // --- Dirección Base (UserProfile) ---
    address: z.string().optional().nullable(),
    street: z.string().optional().nullable(),
    housenumber: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    zipCode: z.string().optional().nullable(),
    country: z.string().default("España"),
    countryCode: z.string().default("ES"),
    latitude: z.number().optional().nullable(),
    longitude: z.number().optional().nullable(),
    language: z.string().optional().nullable(),
    theme: z.string().optional().nullable(),
  })
  .strict();

export const createProfessionalSchema = baseSProfessionalSchema.superRefine(
  validateInternationalId,
);

// An owner already has a UserProfile and Staff membership. This payload only
// contains the fields that belong to the additional Professional record.
export const createProfessionalFromStaffSchema = baseSProfessionalSchema
  .pick({
    specialtyId: true,
    title: true,
    bio: true,
    imageUrl: true,
    licenseNumber: true,
    color: true,
  })
  .strict();

export const updateProfessionalSchema = baseSProfessionalSchema
  .partial()
  .superRefine(validateInternationalId)
  .strict();

export const updateProfessionalImageSchema = z.object({
  imageUrl: z.string().url().nullable(),
});

export const professionalUuidSchema = z.object({
  id: z.string().uuid(),
});

export const staffUuidSchema = z.object({
  staffId: z.string().uuid(),
});

export const updateProfessionalServicesSchema = z.object({
  services: z.array(
    z.object({
      serviceId: z.string().uuid(),
      customPrice: z.number().nullable(),
      customDuration: z.number().nullable(),
    }),
  ),
});
